import React, { HTMLAttributes, useState } from 'react';
import styles from './Switch.module.scss';
import cls from 'classnames';
import { AnimatePresence, AnimateSharedLayout, motion } from 'framer-motion';

export * from './SwitchWithNotification';

const pillTransition = {
  type: 'tween',
};

export function Switch(props: SwitchProps) {
  const [selected, setSelected] = useState(props.initialSelection);

  function onChange(item: SwitchItem) {
    setSelected(item.id);
    props.onChange(item);
  }

  return (
    // Crossfade is the only way to make the buggy behavior with labels be less noticeable
    <AnimateSharedLayout type="crossfade">
      <ul
        className={cls(styles.switch, {
          [styles.square]: props.isSquare,
        })}
        role="tablist"
      >
        {props.items.map((item) => {
          const { id, children, ...rest } = item;
          const isSelected = selected === id;
          return (
            <li {...rest} key={id} className={cls(styles.pill, item.className)} role="presentation">
              <AnimatePresence>
                {isSelected && (
                  <motion.div
                    transition={pillTransition}
                    layoutId="pill-outline"
                    className={cls(styles.color, { [styles.square]: props.isSquare })}
                    animate={{
                      background: props.noColor ? styles.noColorAnimation : styles.animationColor,
                    }}
                    initial={{
                      background: props.noColor ? styles.noColorAnimation : styles.animationColor,
                    }}
                    exit={{
                      background: props.noColor ? styles.noColorAnimation : styles.animationColor,
                    }}
                    aria-hidden
                  />
                )}
              </AnimatePresence>
              <button
                className={styles.text}
                onClick={() => onChange(item)}
                role="tab"
                aria-selected={isSelected}
                aria-label={item.id}
              >
                {children}
              </button>
            </li>
          );
        })}
      </ul>
    </AnimateSharedLayout>
  );
}

export type SwitchProps = {
  initialSelection: string;
  items: SwitchItem[];
  onChange: (item: SwitchItem) => void;
  noColor?: boolean;
  isSquare?: boolean;
  small?: boolean;
};

export type SwitchItem = HTMLAttributes<HTMLLIElement> & {
  id: string;
  children: React.ReactNode;
};
